import { Box, Button, Paper, Typography } from '@mui/material';

import { useBenefitsContent } from './hooks/useBenefitsContent';
import { useAAPIBenefitsStyles } from './useAAPIBenefitsStyles';

export const AAPIBenefits = () => {
  const { classes } = useAAPIBenefitsStyles();
  const { content, keys, t } = useBenefitsContent();

  return (
    <>
      <Typography variant="subtitle1" className={classes.title}>
        {t(keys.title)}
      </Typography>
      <Box className={classes.wrapper}>
        {content.map(
          ({ description, img, linkHref, linkText, list, title }) => {
            return (
              <Paper className={classes.apiWrapper} key={title}>
                <img className={classes.img} src={img} alt="" />

                <div className={classes.mainTextSection}>
                  <Typography className={classes.apiTitle} variant="subtitle2">
                    {title}
                  </Typography>

                  <Typography
                    className={classes.apiDescription}
                    variant="body3"
                    color="textSecondary"
                  >
                    {description}
                  </Typography>
                </div>

                <Box className={classes.apiFeaturesList}>
                  {list.map(item => {
                    return (
                      <code className={classes.apiFeaturesItem} key={item}>
                        {item}
                      </code>
                    );
                  })}
                </Box>

                <Button
                  className={classes.apiLink}
                  variant="text"
                  target="_blank"
                  href={linkHref}
                >
                  {linkText}
                </Button>
              </Paper>
            );
          },
        )}
      </Box>
    </>
  );
};
